/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * EXPORTS
 */
export default gql`
mutation FallbackRoutePlanUpdateMutation($routePlanId: ID, $routePlanIds: [ID!], $input: [FallbackRoutePlanUpdateInput!]!) {
  FallbackRoutePlanUpdate(routePlanId: $routePlanId, routePlanIds: $routePlanIds, input: $input) {
    id,
    message
    status
  }
}
`
